import type { PaymentsMessageId } from "./payments.fr";

/** Paiements in Spanish. Same keys and {placeholders} as payments.fr.ts. */
export const paymentsEs: Record<PaymentsMessageId, string> = {
  "payments.tab.payments": "Pagos",
  "payments.tab.approvals": "Solicitudes de aprobación",
  "payments.pick": "Elija un pago de la lista.",
  "payments.loading": "Cargando el pago…",
  "payments.loadFailed": "No se pudo cargar este pago.",
  "payments.notFound": "No se encuentra este pago. Vuelva a cargar la lista.",
  "payments.refreshFailed": "No se pudo actualizar el pago: se muestra tal como estaba.",

  "payments.filter.provider": "Medio de pago",
  "payments.filter.status": "Estado",
  "payments.filter.all": "Todos",
  "payments.filter.from": "Desde",
  "payments.filter.to": "Hasta",
  "payments.filter.duplicates": "Duplicados probables",
  "payments.filter.clearPro": "Todos los pros",
  "payments.list.loading": "Cargando los pagos…",
  "payments.list.loadFailed": "No se pudieron cargar los pagos.",
  "payments.list.empty": "No hay pagos con estos filtros.",
  "payments.list.aria": "Pagos de tarifas",
  "payments.list.end": "Fin de la lista",
  "payments.pill.duplicate": "Duplicado probable",

  "payments.status.pending": "Por pagar",
  "payments.status.paid": "Pagado",
  "payments.status.failed": "Fallido",
  "payments.status.refunded": "Reembolsado",
  "payments.status.waived": "Tarifa anulada",
  "payments.provider.orange_money": "Orange Money",
  "payments.provider.lengo_pay": "Mobile Money",
  "payments.provider.stripe": "Tarjeta (Stripe)",
  "payments.provider.wave": "Wave",
  "payments.feeType.per_job": "Tarifa por contacto",
  "payments.feeType.monthly": "Suscripción mensual",
  "payments.feeType.yearly": "Suscripción anual",
  "payments.kind.refund": "Reembolso",
  "payments.kind.credit": "Crédito",
  "payments.kind.waive": "Anulación de la tarifa",
  "payments.kind.mark_paid": "Marcado como pagado",

  "payments.detail.versionTitle": "La versión del pago mostrada: cada corrección la envía.",
  "payments.detail.duplicate": "Duplicado probable",
  "payments.detail.duplicateBody":
    "Otro pago del mismo pro, por el mismo importe, unos minutos antes o después. Compruébelo antes de reembolsar:",
  "payments.detail.pro": "Profesional",
  "payments.detail.proPayments": "Sus pagos →",
  "payments.detail.transaction": "Referencia en el proveedor",
  "payments.detail.job": "Solicitud",
  "payments.detail.refunded": "Ya reembolsado",
  "payments.detail.refundable": "Aún reembolsable",
  "payments.detail.credit": "Crédito del pro",
  "payments.detail.adjustments": "Correcciones",
  "payments.detail.noAdjustments": "No hay correcciones en este pago.",
  "payments.detail.actions": "Corregir",
  "payments.detail.neverOptimistic":
    "Nada se muestra como hecho antes de la respuesta del servidor. Un reembolso sin respuesta del proveedor nunca se reenvía.",
  "payments.col.kind": "Corrección",
  "payments.col.amount": "Importe",
  "payments.col.status": "Situación",
  "payments.col.by": "Por",
  "payments.col.actions": "Acciones",

  "payments.adjustment.status.pending": "Estado desconocido, en comprobación",
  "payments.adjustment.status.done": "Hecho",
  "payments.adjustment.status.failed": "Rechazado por el proveedor",
  "payments.adjustment.status.awaiting_manual_transfer": "Transferencia manual pendiente",
  "payments.adjustment.status.awaiting_approval": "Pendiente de aprobación",
  "payments.adjustment.status.rejected": "Rechazado por el propietario",
  "payments.adjustment.outcomeUnknownHint":
    "Enviado al proveedor sin respuesta. Nunca se reenvía: compruébelo en su panel y después liquídelo.",
  "payments.adjustment.manualHint":
    "Orange Money no tiene reembolso automático: envíe el dinero a mano y después liquídelo con la referencia de la transferencia.",

  "payments.action.refund": "Reembolsar",
  "payments.action.credit": "Abonar crédito",
  "payments.action.waive": "Anular la tarifa",
  "payments.action.markPaid": "Marcar como pagado",
  "payments.action.settle": "Liquidar",
  "payments.action.approve": "Aprobar",
  "payments.action.reject": "Rechazar",

  "payments.dialog.refund.title": "Reembolsar · {subject}",
  "payments.dialog.refund.body":
    "El reembolso se guarda y luego se envía una sola vez al proveedor. Por encima del límite, espera la aprobación de un propietario.",
  "payments.dialog.credit.title": "Abonar crédito · {subject}",
  "payments.dialog.credit.body": "Un saldo que se descuenta de las próximas tarifas del pro, en la misma moneda.",
  "payments.dialog.waive.title": "Anular la tarifa · {subject}",
  "payments.dialog.waive.body":
    "La tarifa deja de adeudarse. Por encima del límite, la anulación espera la aprobación de un propietario.",
  "payments.dialog.markPaid.title": "Marcar como pagado · {subject}",
  "payments.dialog.markPaid.body":
    "Solo con la referencia del pago real (el SMS del pro o el extracto). Una referencia marca un único pago.",
  "payments.dialog.settle.title": "Liquidar el reembolso · {subject}",
  "payments.dialog.settle.body": "Anote cómo terminó el reembolso, una vez comprobado en el proveedor.",
  "payments.dialog.approve.title": "Aprobar la solicitud de {subject}",
  "payments.dialog.approve.body": "La corrección solicitada se aplica desde ahora. Nadie aprueba su propia solicitud.",
  "payments.dialog.reject.title": "Rechazar la solicitud de {subject}",
  "payments.dialog.reject.body": "No se reembolsa ni se anula nada. El motivo se guarda con la solicitud.",
  "payments.field.amount": "Importe ({currency})",
  "payments.field.refundHint": "Déjelo vacío para reembolsar todo: {amount}.",
  "payments.field.orangeMoneyReference": "Referencia de la transacción Orange Money",
  "payments.field.reference": "Referencia en el proveedor",
  "payments.field.referenceHint": "Cópiela entera desde el SMS o el extracto: letras, cifras y . _ : / -",
  "payments.field.outcome": "Resultado",
  "payments.field.outcome.done": "El dinero se envió",
  "payments.field.outcome.failed": "El reembolso falló",

  "payments.problem.reason": "Indique un motivo de al menos {min} caracteres.",
  "payments.problem.amount": "Introduzca un importe mayor que cero, con dos decimales como máximo.",
  "payments.problem.tooMuch": "Es más de lo que queda por reembolsar.",
  "payments.problem.reference":
    "Copie la referencia entera: al menos {min} caracteres, solo letras, cifras y . _ : / -.",

  "payments.outcome.done": "{kind} de {amount}: hecho.",
  "payments.outcome.pending":
    "{kind} de {amount}: estado desconocido, en comprobación. No se reenviará; liquídelo una vez comprobado.",
  "payments.outcome.awaiting_manual_transfer":
    "{kind} de {amount} guardado: envíe el dinero a mano y después liquídelo con la referencia.",
  "payments.outcome.awaiting_approval": "{kind} de {amount}: más de lo que puede hacer solo, espera una aprobación.",
  "payments.outcome.failed": "{kind} de {amount} rechazado por el proveedor ({failure}). No se ha movido nada.",
  "payments.outcome.rejected": "{kind} de {amount} rechazado.",

  "payments.approvals.status.pending": "Pendientes",
  "payments.approvals.status.approved": "Aprobadas",
  "payments.approvals.status.rejected": "Rechazadas",
  "payments.approvals.loading": "Cargando las solicitudes…",
  "payments.approvals.loadFailed": "No se pudieron cargar las solicitudes de aprobación.",
  "payments.approvals.empty": "No hay solicitudes aquí.",
  "payments.approvals.requested": "Solicitado por {name} el {date}",
  "payments.approvals.permission": "Permiso: {permission}",
  "payments.approvals.theirLimit": "Su límite: {amount}",
  "payments.approvals.noPermission": "Esta persona no tiene este permiso.",
  "payments.approvals.noLimitInCurrency": "Esta persona no tiene límite en esta moneda.",
  "payments.approvals.openPro": "Abrir el profesional →",
  "payments.approvals.decided": "Resuelto por {name} el {date}",
  "payments.approvals.openPayment": "Abrir el pago →",
  "payments.approvals.own": "Es su solicitud: otro propietario debe resolverla.",

  "payments.export.month": "Mes a exportar",
  "payments.export.reason": "Motivo (opcional)",
  "payments.export.button": "Exportar el CSV",
  "payments.export.running": "Exportando…",
  "payments.export.hint":
    "Los pagos del mes (UTC) para la conciliación, sin teléfono ni correo. Cada exportación queda en el registro de auditoría.",
  "payments.export.done": "Exportación descargada. Queda en el registro de auditoría.",

  "payments.error.stale": "Este pago cambió mientras lo miraba. Vuelva a cargarlo, compruébelo y empiece de nuevo.",
  "payments.error.refused":
    "Corrección rechazada: sus roles no incluyen la función necesaria. Pida acceso a un responsable.",
  "payments.error.approvalRefused":
    "Rechazado: solo un propietario con APPROVE_PAYMENT_REQUESTS puede resolver, y nunca su propia solicitud.",
  "payments.error.invalid":
    "Rechazado: el pago ya no está en el estado esperado, el importe supera lo que queda o la referencia ya se usó. Vuelva a cargar y compruebe.",
  "payments.error.outcomeUnknown":
    "Sin respuesta del servidor: puede que la corrección se haya guardado. Inténtelo de nuevo: el mismo clic no puede aplicarse dos veces.",

  "payments.refused.notRefundable": "Rechazado: solo se puede reembolsar una tarifa pagada. Vuelva a cargar el pago.",
  "payments.refused.nothingToRefund":
    "Rechazado: esta tarifa ya está reembolsada por completo, o el resto está pendiente. Vuelva a cargar el pago.",
  "payments.refused.refundTooLarge": "Rechazado: el importe supera lo que queda por reembolsar de esta tarifa.",
  "payments.refused.alreadyAwaitingApproval":
    "Rechazado: una exención de esta tarifa ya espera a un propietario. Vuelva a cargar el pago.",
  "payments.refused.notMarkable":
    "Rechazado: solo una tarifa pendiente o fallida puede marcarse como pagada. Vuelva a cargar el pago.",
  "payments.refused.referenceInUse":
    "Rechazado: esta referencia de Orange Money ya pagó otra tarifa. Compruebe la referencia.",
  "payments.refused.referenceRequired": "Introduzca la referencia de la transacción.",
  "payments.refused.alreadySettled": "Este reembolso se acaba de liquidar. Vuelva a cargarlo.",
  "payments.refused.alreadyDecided": "Esta solicitud se acaba de resolver. Vuelva a cargar la lista.",
  "payments.refused.ownRequest": "Rechazado: usted hizo esta solicitud, así que la resuelve otro propietario.",
  "payments.refused.approverNotPermitted":
    "No tiene este permiso para este importe, así que no puede resolver. Otra persona lo resuelve.",
  "payments.refused.paymentChanged":
    "Rechazado: el pago cambió desde la solicitud. Recházela en su lugar, con el motivo.",
  "payments.refused.currencyMismatch": "Rechazado: el crédito debe estar en la moneda de la tarifa.",
  "payments.refused.feeOfAnotherPro": "Rechazado: esta tarifa la pagó otro profesional.",
  "payments.refused.invalidAmount": "Rechazado: el importe debe ser mayor que cero.",
};
